import { adaptAdditionalDataDTO } from 'entities/counterparties/model/adapters/adaptAdditionalDataDTO'
import { CounterpartyDto } from '../dtoTypes'
import { Counterparty } from '../types'
import { adaptCounterpartyContactDTO } from 'entities/counterparties/model/adapters/adaptCounterpartyContactDTO'
import { adaptDocumentPhotos } from 'entities/counterparties/model/adapters/adaptDocumentPhotos'

// TODO: remove duplicate
export const adaptCounterpartiesDTO = (dto: CounterpartyDto): Counterparty => ({
    id: dto.id,
    type: dto.type,
    phone: dto.phone,
    email: dto.email,
    profilePhoto: dto?.profile_photo
        ? adaptDocumentPhotos(dto.profile_photo)
        : null,
    documentPhotos: (dto?.document_photos ?? [])?.map(adaptDocumentPhotos),
    contacts: dto.contacts ? dto.contacts.map(adaptCounterpartyContactDTO) : [],
    contact: dto.contacts?.[0]
        ? adaptCounterpartyContactDTO(dto.contacts?.[0])
        : null,
    discount: parseFloat(dto.discount),
    isBlackList: dto.is_black_list,
    comment: dto.comment,
    bookingHours: dto.booking_hours,
    additionalData: adaptAdditionalDataDTO(dto?.additional_data),
    createdAt: new Date(dto.created_at)
})
